import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Button from 'Common/CustomButtons/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class Lightbox extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        children: PropTypes.node,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        submitBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        handleSubmit: PropTypes.func,
        submitDisabled: PropTypes.bool,
        isOpen: PropTypes.bool,
        handleClose: PropTypes.func,
        dialogActions: PropTypes.bool,
        customClass: PropTypes.string,
        maxWidth: PropTypes.string,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        submitBtnText: <FormattedMessage id={'button.lightbox.submit'}/>,
        openBtnColor: 'primary',
        submitDisabled: false,
        dialogActions: true,
        maxWidth: 'sm',
    };

    render() {
        const {children, text, title, submitBtnText, submitDisabled,
            isOpen, handleClose, dialogActions, customClass, maxWidth} = this.props;

        return (
            <Dialog
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                className={customClass}
                fullWidth
                maxWidth={maxWidth}
            >
                { title &&
                    <DialogTitle id="form-dialog-title">
                        {title}
                    </DialogTitle>
                }
                <DialogContent>
                    {text &&
                        <DialogContentText>
                            {text}
                        </DialogContentText>
                    }
                    {children}
                </DialogContent>
                {dialogActions && <DialogActions>
                    <Button onClick={handleClose} color="danger">
                        <FormattedMessage id={'button.lightbox.cancel'}/>
                    </Button>
                    <Button type="submit" color="success" disabled={submitDisabled} right>
                        {submitBtnText}
                    </Button>
                </DialogActions>}
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Lightbox/Lightbox.jsx